import React from 'react';
import {
  Card,
  Box,
  CircularProgress,
  Alert,
} from '@mui/material';
import { PdfCanvasViewer, hasNativePdfViewer } from '../../../PdfCanvasViewer';

/**
 * PDFPreview - Component for previewing PDF files
 */
export const PDFPreview = ({ 
  file,
  imageUrl,
  loading,
  error,
}) => {
  return (
    <Card sx={{ bgcolor: 'grey.100', flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
      {loading && (
        <Box display="flex" justifyContent="center" alignItems="center" flex={1}>
          <CircularProgress />
        </Box>
      )}
      {error && (
        <Alert severity="error" sx={{ m: 2 }}>
          {error}
        </Alert>
      )}
      {imageUrl && !loading && !hasNativePdfViewer() && (
        <PdfCanvasViewer url={imageUrl} title={file.filename} />
      )}
      {imageUrl && !loading && hasNativePdfViewer() && (
        <embed
          // The browser's own PDF toolbar would repeat download and print; the
          // sidebar has download, and fullscreen keeps the full toolbar
          src={`${imageUrl}#toolbar=0&navpanes=0&view=FitH`}
          type="application/pdf"
          style={{
            width: '100%',
            flex: 1,
            border: 'none',
          }}
          title={file.filename}
        />
      )}
    </Card>
  );
};